var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnverifiedNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20px/not_verified_300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99689 12.6799C10.1627 12.6799 10.3032 12.6238 10.4183 12.5116C10.5335 12.3995 10.591 12.2604 10.591 12.0946C10.591 11.9287 10.5349 11.7883 10.4227 11.6731C10.3105 11.558 10.1715 11.5005 10.0057 11.5005C9.83982 11.5005 9.69933 11.5566 9.58422 11.6688C9.46911 11.781 9.41155 11.92 9.41155 12.0858C9.41155 12.2517 9.46765 12.3921 9.57984 12.5073C9.69202 12.6224 9.83104 12.6799 9.99689 12.6799ZM9.45964 10.1768H10.5429V6.32101H9.45964V10.1768ZM10.0013 17.5677C8.25449 17.1041 6.80391 16.0894 5.64953 14.5238C4.49516 12.9581 3.91797 11.2073 3.91797 9.2713V4.78895L10.0013 2.44922L16.0846 4.78895V9.2713C16.0846 11.2073 15.5074 12.9581 14.353 14.5238C13.1987 16.0894 11.7481 17.1041 10.0013 17.5677ZM10.0013 16.438C11.4457 15.9901 12.6402 15.0942 13.5846 13.7505C14.5291 12.4067 15.0013 10.9137 15.0013 9.2713V5.5213L10.0013 3.61266L5.00128 5.5213V9.2713C5.00128 10.9137 5.4735 12.4067 6.41795 13.7505C7.36239 15.0942 8.55684 15.9901 10.0013 16.438Z",
    fill: "#F87700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverifiedNew);
export default __webpack_public_path__ + "static/media/unverifiedNew.71054124032d2357d0a0e7744be40e58.svg";
export { ForwardRef as ReactComponent };